import React from "react";
import { connect } from "react-redux";
import "react-notifications/lib/notifications.css";
import "./verify.style.css";
import UserService from "../../services/user/user.service";
import { NotificationManager } from "react-notifications";
import MqttService from "../../services/mqtt/mqtt.service";
import { validateCode, reset } from "../../store/auth/auth.actions";
import { bindActionCreators } from "redux";
import { Backdrop, CircularProgress } from "@mui/material";
import { CustomOtpInput } from "../../components/otp-input/otp-input.component";

export class Verify extends React.Component {
    constructor(props) {
        super(props);
        this.codeRegex = new RegExp("^[0-9]{8}$");
        this.state = {
            isLoading: false,
            code: "",
        };
    }

    componentDidMount() {
        this.props.reset();
        window.scrollTo(0, 0);
    }

    validateCode = async (event) => {
        event.preventDefault();
        if (this.state.code.length !== 8) {
            NotificationManager.error("", "Please Enter Code", 3000);
        } else if (!this.codeRegex.test(this.state.code)) {
            NotificationManager.error("", "Please Enter Complete Code", 3000);
        } else {
            try {
                this.setState({ isLoading: true });
                const res = await UserService.validateCode(this.state.code);
                if (res.error != null) {
                    this.setState({ isLoading: false });
                    if (res.error.response !== undefined) {
                        if (res.error.response.data !== undefined) {
                            if (
                                res.error.response.data instanceof String ||
                                typeof res.error.response.data === "string"
                            ) {
                                NotificationManager.error("", res.error.response.data, 3000);
                            } else if (
                                res.error.response.data.message !== undefined &&
                                (res.error.response.data.message instanceof String ||
                                    typeof res.error.response.data.message === "string")
                            ) {
                                NotificationManager.error("", res.error.response.data.message, 3000);
                            } else {
                                NotificationManager.error("", "Validation Failed.", 3000);
                            }
                        }
                    }
                } else {
                    if (res["status"]) {
                        const data = res["data"];
                        this.props.validateCode({ isCodeValid: true, appId: data.appId, code: this.state.code });
                        MqttService.initializeMqtt(data.subscribingChannel);
                        this.setState({ isLoading: false });
                        this.props.history.push("/signin");
                    } else {
                        NotificationManager.error("", "Error while Validating Code.", 3000);
                        this.setState({ isLoading: false });
                    }
                }
            } catch (err) {
                NotificationManager.error("", err, 3000);
                this.setState({ isLoading: false });
            }
        }
    };

    render() {
        return (
            <>
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={this.state.isLoading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>

                <div className="homeWapper">
                    <h1>Enter the code displayed on your TV</h1>
                    <form
                        onSubmit={(event) => this.submitHandler(event)}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {/* <OtpInput
                            value={this.state.code}
                            focusStyle="focusStyle"
                            onChange={(code) => this.setState({ code })}
                            numInputs={8}
                            separator={<span></span>}
                            inputStyle="inputStyle"
                            containerStyle="containerStyle"
                            isInputNum={true}
                        /> */}

                        <CustomOtpInput onChange={(otp) => this.setState({ code: otp })} />

                        <button className="buttonComponent" onClick={this.validateCode}>
                            Enter Code to Continue
                        </button>
                    </form>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators(
        {
            validateCode,
            reset,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Verify);
